export default __webpack_public_path__ + "static/media/pan-vino.31c085a0.png";